import { EffectCallback, useEffect } from 'react';

// biome-ignore lint/correctness/useExhaustiveDependencies: effectCallback should only run once
export const useEffectOnce = (effectCallback: EffectCallback) => useEffect(effectCallback, []);
